export enum AppRoutePaths {
  Healthcheck = 'healthcheck',
  Requests = 'requests',
  NoPermission = 'no-permission',
  PersonRequired = 'person-required',
  AllRequests = '/requests/all',
  Warehouse = 'warehouse',
  Payroll = 'payroll',
  Docflow = 'docflow',
  Profile = 'profile',
  RequestView = 'request-view', // ограниченный просмотр заявки для заказчиков
  RequestGuestView = 'request-guest-view',
  LogistTimeManagement = 'logist-time-management',
  LogistTMRequestsDistribution = 'logist-time-management/requests-distribution',
  LogistTMRequestsRegistry = 'logist-time-management/requests-registry',
}

export const REQUEST_LIST_ROUTE_PATHS: string[] = [AppRoutePaths.AllRequests];

export const REQUEST_LIST_ROUTE_SEGMENTS: string[] = ['all'];

export enum PageContext {
  /** Список заявок — «главный» экран */
  RequestList = 'request-list',
  /** Страница конкретной заявки */
  RequestPage = 'request-page',
  /** Страница профиля */
  ProfilePage = 'profile-page',
  /** Любая другая вложенная страница (docflow, etc.) */
  Other = 'other',
}
